import React, { useEffect, useState } from 'react';
import CVGauge from './CVGauge';

const SOURCES = [
  '2Seam',
  '4SeamLower',
  '4SeamA',
  '4SeamUpper',
  'MixedOversize',
  'Rewash Coal',
];

function ProductNARGauges({ range = '7d', start, end }) {
  const [values, setValues] = useState({});

  const thresholds = {
    '2Seam': [0, 11750],
    '4SeamA': [0, 11750],
    '4SeamLower': [0, 10100],
    '4SeamUpper': [0, 10100],
    'MixedOversize': [0, 11050],
    'Rewash Coal': [0, 9600],
  };

  useEffect(() => {
    const srcParam = SOURCES.map(encodeURIComponent).join(',');
    const params = start && end
      ? `start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
      : `time_range=${range}`;
    fetch(`/api/coal-quality-avg.php?${params}&sources=${srcParam}`)
      .then(res => res.json())
      .then(res => setValues(res || {}))
      .catch(() => setValues({}));
  }, [range, start, end]);

  const targets = {
    '2Seam': 5875,
    '4SeamLower': 5050,
    '4SeamA': 5875,
    '4SeamUpper': 5050,
    'MixedOversize': 5525,
    'Rewash Coal': 4800,
  };

  return (
    <div className="mt-4 flex-1 space-y-2">
      <div className="grid grid-cols-7 gap-4 items-end">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Current
        </div>
        {SOURCES.map(src => (
          <CVGauge
            key={src}
            source={src}
            value={values[src] || 0}
            thresholds={thresholds[src]}
            showSideLabels={false}
            gradient
          />
        ))}
      </div>
      <div className="grid grid-cols-7 gap-4 items-center">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Target
        </div>
        {SOURCES.map(src => (
          <div key={src} className="flex items-center justify-center">
            <span className="px-1.5 py-0.5 rounded-full text-white text-[12px] font-semibold" style={{ backgroundColor: '#21C55E' }}>
              {targets[src]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductNARGauges;
